<template>
  <Transition name="fade-fast">
    <div
        class="error-view-z-index w-100 position-absolute top-0 left-0"
        :class="{ 'br-8 border-white border-dashed border-1 h-100': mode, 'h-100': !mode }"
        v-if="currentError !== null"
        @click.stop.prevent
    >
      <ErrorGenericView
          v-if="currentError.type === ERROR_TYPE.GENERIC"
          :title="currentError.title"
          :description="currentError.description"
          :can-dismiss="currentError.canDismiss"
          :show-try-premium-button="currentError.showTryPremiumButton"
          :show-start-button="currentError.showStartButton"
          :show-sign-up-button="currentError.showSignUpButton"
          :show-referral-button="currentError.showReferralButton"
          :is-state-loading="isStateLoading"
          :button-text="premiumText"
          :back-button-text="translate('No thanks')"
          @dismiss.stop.prevent="dismiss"
          @generic-action.stop.prevent="handlePayment"
          @start-task.stop.prevent="startConversion"
          @sign-up.stop.prevent="signUp"
          @refer-a-friend.stop.prevent="referAFriend"
      ></ErrorGenericView>

      <ErrorCountdownView
          v-else-if="currentError.type === ERROR_TYPE.COUNTDOWN"
          :is-state-loading="isStateLoading"
          :show-try-premium-button="currentError.showTryPremiumButton"
          :show-start-button="currentError.showStartButton"
          :show-sign-up-button="currentError.showSignUpButton"
          :show-referral-button="currentError.showReferralButton"
          :current-error="currentError"
          @dismiss.stop.prevent="dismiss"
          @generic-action.stop.prevent="handlePayment"
          @sign-up.stop.prevent="signUp"
          @refer-a-friend.stop.prevent="referAFriend"
      ></ErrorCountdownView>
    </div>
  </Transition>
</template>

<script>
import ErrorGenericView from './views/ErrorGenericView';
import ErrorInputLimitReachedView from './views/ErrorCountdownView';
import ErrorCountdownView from './views/ErrorCountdownView';
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import {getDisplayErrorDataFromStoreEntryLimits} from './error-container-helper';
import {UPLOAD_BOX_ERROR_TYPE} from '../const';
import {LIMIT_CREDITS_CONSUMED} from '../../../limits/limits';
import {testIsEmptyArray, testIsNull} from '../../../../lib/test-and-assert/test-base';
import {pageStoreMixin} from '../../../store/page-store';
import {globalLogger} from '../../../../qaamgo/helper/global-logger';
import {testIsLimit} from '../../../limits/test';
import {translate} from '../../../../qaamgo/helper/translate';
import {satGlobals} from '../../../../qaamgo/sat/helper/sat-globals';
import {translatePath} from '../../../../qaamgo/sat/helper/translate-path';
import {satUserManager} from '../../../user/sat-user';
import {userManager} from '../../../user/user-manager';
import {registerPaymentModalHelper} from '../../../user/modal/register_payment_flow/register-payment-modal-helper';

export default {
  name: 'ErrorContainer',
  components: {ErrorCountdownView, ErrorInputLimitReachedView, ErrorGenericView},
  props: {
    mode: {
      type: String,
      default: '',
    },
  },
  mixins: [TransFilter, pageStoreMixin],
  computed: {
    currentLimits() {
      return this.store.limits.getLimits;
    },
    premiumText() {
      let isEligibleForFreeTrial = false;
      let isPremiumUser = false;

      let tempUser = satUserManager.getUserDataFromSessionStorage();

      const user = userManager.getCurrentUserFromStore();

      if (user) {
        isPremiumUser = user.isPremium();
      }

      if (tempUser !== null) {
        if (tempUser.isEligibleForFreeTrial) {
          isEligibleForFreeTrial = true;
        }
      }

      if (satGlobals.getEnableFreeTrial() && isEligibleForFreeTrial) {
        return translate('Try premium for %count% days free').replace(
            '%count%',
            satGlobals.getFreeTrialPeriod()
        );
      }
      if (satGlobals.isCreditsEnabled && this.currentError?.name === LIMIT_CREDITS_CONSUMED && isPremiumUser) {
        return translate('Get Add-on');
      }
      return translate('Go Premium');
    },
  },
  watch: {
    // Watching currentLimits with deep: true
    currentLimits: {
      handler(/** ?StoreEntryLimit[] */ limitsList) {
        // do not show new error message if we already show one
        if (this.currentError !== null) {
          return;
        }

        if (testIsNull(limitsList) || testIsEmptyArray(limitsList)) {
          return;
        }

        let errorData = getDisplayErrorDataFromStoreEntryLimits(limitsList);

        // TODO add testIsErrorData?
        if (testIsNull(errorData)) {
          return;
        }

        this.store.uploader.setDisplayLimitError(errorData);

        this.currentError = errorData;
      },
      deep: true,  // Deep watch added here
    },
    currentError: {
      handler(/** ?DisplayLimitError*/ currentError) {
        const $buttons = $('.submit-btn');

        this.log(currentError);

        if (currentError === null) {
          //$buttons.prop('disabled', false);
          return;
        }

        //$buttons.prop('disabled', true);
      },
      deep: true,  // Deep watch added here
    },
  },
  methods: {
    startConversion() {
      this.isStateLoading = true;

      $('.submit-btn').click();
      globalLogger.log('error box - start task');

      // reset loading state after 20s
      setTimeout(() => {
        this.isStateLoading = false;
      }, 20000);
    },
    dismiss() {
      if (this.isStateLoading) {
        return;
      }

      this.store.uploader.setDisplayLimitError(null);

      this.currentError = null;
    },
    async handlePayment() {
      this.isStateLoading = true;

      const getUser = await userManager.getUser();

      if (satGlobals.isCreditsInAllSatsEnabled()) {
        registerPaymentModalHelper.openUpgrade();
      } else {
        registerPaymentModalHelper.openUpgrade();
      }

      this.isStateLoading = false;

      const lim = this.currentError.name.replace('limit-', '');

      globalLogger.log(`error box - click payment button ${lim}`);
    },
    signUp() {
      registerPaymentModalHelper.openForPricingFree();
    },
    referAFriend() {
      window.location = satGlobals.getAccountUrl() + translatePath('/user/referral');
    },
    log(/** ?DisplayLimitError*/ currentError) {
      let message = 'error box - unknown limit';

      if (currentError === null) {
        message = 'error box - dismiss';
      } else {
        if (testIsLimit(currentError.name)) {
          const lim = currentError.name.replace('limit-', '');

          message = `error box - ${lim}`;
        }
      }

      globalLogger.log(message);
    },
  },
  data() {
    return {
      currentError: null,
      isStateLoading: false,
      ERROR_TYPE: UPLOAD_BOX_ERROR_TYPE,
    };
  },
};
</script>
